<template>
    <span
        @mouseover="mouseover"
        @mouseleave="mouseleave"
    >
        <a :href="adminItems.url" id="admin-nav-link" :class="isAdminPath">{{ menuName }}</a>
        <div class="dropdown" :class="{ isOpen }">
            <div :key="i" v-for="(children, i) in adminItems.children">
                <div class="sub-nav-menu-header">{{ i }}</div>
                <ul style="list-style-type:none; padding: 0px;">
                    <li :key="i" v-for="(c, i) in children">
                        <a :href="c.url">
                            {{ c.link_name }}
                        </a>
                    </li>
                </ul>
            </div>

        </div>
    </span>
</template>

<script>
export default {
    name: "AdminNavMenu",
    props:['adminItems', 'menuName'],
    data() {
        return {
            data: undefined,
            isOpen: false,
        }
    },
    computed: {
        isAdminPath() {
            return window.location.pathname.includes('admin') ? "bold" : "";
        },
    },
    methods: {
        mouseover: function () {
            this.isOpen = true;
        },
        mouseleave: function () {
            this.isOpen = false;
        }
    }
}
</script>

<style scoped>

</style>
